<form [formGroup]="paymentInputFG">
  <div class="p-input-block01__item">
    <div class="p-input-block01__row p-input-block01__row--has-title">
      <div class="p-input-block01__row-head">
        <span class="p-input-block01__row-title" [innerHTML]="travelerName"></span>
      </div>
      <div class="p-input-block01__row-body">
        <div class="p-input-block01__row-body-item">
          <!-- [8.5] 搭乗情報メール送信先 -->
          <asw-radio-group
            id="{{ id }}-select-mail-type"
            name="radiobutton_{{ id }}"
            [formControlName]="'emailDestination_' + traveler.id"
            (change$)="onChangeEmailDestination()"
            direction="vertical"
          >
            <asw-radio-button
              id="{{ id }}-select-mail-type-item-1"
              value="0"
              label="{{ 'label.sameAsRequestMailAddress2' | staticMsg }}"
            ></asw-radio-button>
            <asw-radio-button
              id="{{ id }}-select-mail-type-item-2"
              value="1"
              label="{{ 'label.differentAsRequestMailAddress1' | staticMsg }}"
            ></asw-radio-button>
          </asw-radio-group>
        </div>
      </div>
    </div>
    <!-- [8.6] 搭乗情報連絡先メールアドレス入力エリア -->
    <!-- 搭乗者情報メール送信先で個人に送るが選択されている場合、表示する。 -->
    <div class="p-input-block01__row p-input-block01__row--has-title" *ngIf="isDisplayPassengerEmailInputArea">
      <div class="p-input-block01__row-head">
        <span class="p-input-block01__row-title" [innerHTML]="'label.eMailAddress.passengerInput' | staticMsg"></span>
        <span class="c-label-required" [innerHTML]="'message.mandatory' | staticMsg"></span>
      </div>
      <div class="p-input-block01__row-body">
        <div class="p-input-block01__row-body-item">
          <div class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w294">
            <span class="u-visually-hidden" [innerHTML]="'reader.eMailAddress' | staticMsg"></span>
            <asw-input
              id="{{ id }}-input-address"
              label="{{ 'label.eMailAddress' | staticMsg }}"
              placeholder="{{ 'placeholder.eMailAddress' | staticMsg }}"
              [formControlName]="'emailAddress_' + traveler.id"
              maxlength="50"
              [conversionType]="'email'"
              (change$)="emailChange()"
            ></asw-input>
          </div>
        </div>
        <div class="p-input-block01__row-body-item">
          <div class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w294">
            <span class="u-visually-hidden" [innerHTML]="'reader.confirmMailAddress' | staticMsg"></span>
            <!-- [8.8.3] 未登録として扱うペースト操作は不可とする -->
            <asw-input
              id="{{ id }}-input-address-confirm"
              label="{{ 'label.confirmMailAddress' | staticMsg }}"
              placeholder="{{ 'placeholder.eMailAddress' | staticMsg }}"
              [formControlName]="'emailAddressConfirm_' + traveler.id"
              maxlength="50"
              [conversionType]="'email'"
              (change$)="emailChange()"
              [disablePaste]="true"
            ></asw-input>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
